import { OrderType } from "../types";
import { RiEBike2Line } from "react-icons/ri";
import { MdOutlineShoppingBag } from "react-icons/md";
import { ROUTES } from "./route.config";

const LISTS = {
  DELIVERY_OPTIONS: [
    {
      label: OrderType.DELIVERY,
      icon: RiEBike2Line,
    },
    {
      label: OrderType.PICKUP,
      icon: MdOutlineShoppingBag,
    },
  ],
  REQUESTS: [
    {
      title: "Étendez votre zone de livraison",
      btnTitle: "Ajouter votre restaurant",
      imagePath: "/assets/images/restaurant-request.png",
      redirectionPath: ROUTES.RESTAURANT_REQUEST,
    },
    {
      title: "Travaillez en toute liberté",
      btnTitle: "Devenez coursier",
      imagePath: "/assets/images/rider-request.png",
      redirectionPath: ROUTES.RIDER_REQUEST,
    },
  ],
  STORES: [
    {
      imagePath: "/assets/logos/app-store.png",
      title: "L'App Store",
    },
    {
      imagePath: "/assets/logos/play-store.png",
      title: "Google Play",
    },
  ],
  HOME_FEATURES: [
    {
      text: (
        <>
          Livraison jusqu&apos;à{" "}
          <span className="text-primary font-semibold">25 km</span>
        </>
      ),
      image: "/assets/icons/delivery-pin.png",
    },
    {
      text: (
        <>
          Paiement <span className="text-primary font-semibold">équitable</span>{" "}
          pour les livreurs
        </>
      ),
      image: "/assets/icons/delivery-rider.png",
    },
    {
      text: (
        <>
          Promotions exclusives{" "}
          <span className="text-primary font-semibold">chaque jour</span>
        </>
      ),
      image: "/assets/icons/promotion-cart.png",
    },
  ],
  RESTAURANT_REQUEST_FEATURES: [
    {
      text: (
        <>
          Entreprise{" "}
          <span className="text-primary font-semibold">française </span> de
          livraison de restauration à domicile
        </>
      ),
      image: "/assets/icons/basket.png",
    },
    {
      text: (
        <>
          Expérience client{" "}
          <span className="text-primary font-semibold">simplifiée</span> avec la
          commande en quelques clics
        </>
      ),
      image: "/assets/icons/shopping-cart.png",
    },
    {
      text: (
        <>
          Augmentez votre
          <span className="text-primary font-semibold">
            {" "}
            nombre de client{" "}
          </span>{" "}
          et votre{" "}
          <span className="text-primary font-semibold">
            {" "}
            panier moyen{" "}
          </span>{" "}
          avec un nouveau canal de vente
        </>
      ),
      image: "/assets/icons/worker.png",
    },
    {
      text: (
        <>
          Bénéficiez de l’offre marketing de l’application et de sa{" "}
          <span className="text-primary font-semibold">visibilité </span> en
          ligne
        </>
      ),
      image: "/assets/icons/shopping-cart.png",
    },
  ],
  RESTAURANT_REQUEST_SERVICES_FEATURES: [
    {
      text: (
        <>
          Paiement en
          <span className="text-primary font-semibold"> 1 clic </span> via
          l’application
        </>
      ),
      image: "/assets/icons/cursor.png",
    },
    {
      text: (
        <>
          Votre
          <span className="text-primary font-semibold"> menu</span>, vos prix
        </>
      ),
      image: "/assets/icons/screen.png",
    },
    {
      text: (
        <>
          Rayons de
          <span className="text-primary font-semibold"> livraison étendus</span>
        </>
      ),
      image: "/assets/icons/worker.png",
    },
    {
      text: (
        <>
          Opération
          <span className="text-primary font-semibold"> Marketing </span> en
          ligne de votre restaurant
        </>
      ),
      image: "/assets/icons/shopping-cart.png",
    },
  ],
  RESTAURANT_REQUEST_STEPS: [
    "Signez notre accord de partenariat sans engagement et sans frais de service.",
    "Votre menu est digitalisé par nos soins sur notre plateforme.",
    "Nous mettons une tablette à disposition équipée de notre technologie.",
    "Connectez-vous et préparez votre première commande !",
  ],
  RIDER_REQUEST_FEATURES: [
    {
      text: (
        <>
          Entreprise{" "}
          <span className="text-primary font-semibold">française </span> de
          livraison de restauration à domicile
        </>
      ),
      image: "/assets/icons/flag.png",
    },
    {
      text: (
        <>
          Contribuez au dynamisme
          <span className="text-primary font-semibold">
            {" "}
            de petits commerces{" "}
          </span>
        </>
      ),
      image: "/assets/icons/commerce.png",
    },
    {
      text: (
        <>
          <span className="text-primary font-semibold">Flexibilité</span> des
          horaires
        </>
      ),
      image: "/assets/icons/schedule.png",
    },
    {
      text: (
        <>
          Une rémunération intéressante pour un
          <span className="text-primary font-semibold">
            {" "}
            complément de salaire{" "}
          </span>
        </>
      ),
      image: "/assets/icons/payment.png",
    },
  ],
  RIDER_REQUEST_SERVICES_FEATURES: [
    {
      text: (
        <>
          En tant que coursier partenaire vous pourrez obtenir une
          <span className="text-primary font-semibold">
            {" "}
            rémunération attractive{" "}
          </span>{" "}
          en fonction de la demande sur votre lieu de travail
        </>
      ),
      image: "/assets/icons/payment.png",
    },
    {
      text: (
        <>
          Recevez notre sac de transport
          <span className="text-primary font-semibold"> adapté </span> à la
          livraison de restauration
        </>
      ),
      image: "/assets/icons/package.png",
    },
    {
      text: (
        <>
          Une plateforme d’
          <span className="text-primary font-semibold">d’Assistance </span>est à
          votre disposition de 9H30 à 22H30, 7j/7 pour vous aider en cas de
          problèmes
        </>
      ),
      image: "/assets/icons/assistant.png",
    },
  ],
  RIDER_REQUEST_STEPS: [
    "Renseignez vos informations",
    "Notre équipe Riders vous contactera pour vous donner toutes les informations dont vous avez besoin",
    "Vous pourrez alors compléter votre fiche d’information et signer nos chartes",
    "Votre équipement sera mit à disposition dans votre zone de couverture",
    "Connectez-vous et effectuez votre première course !",
  ],
};

export const {
  DELIVERY_OPTIONS,
  REQUESTS,
  STORES,
  HOME_FEATURES,
  RESTAURANT_REQUEST_FEATURES,
  RESTAURANT_REQUEST_SERVICES_FEATURES,
  RESTAURANT_REQUEST_STEPS,
  RIDER_REQUEST_FEATURES,
  RIDER_REQUEST_SERVICES_FEATURES,
  RIDER_REQUEST_STEPS,
} = LISTS;

// TODO : make folder data & seperate these lists to multiple files when u finish putting all lists here
